import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavigComponent } from './top-navig/top-navig.component';
// import { OurAppComponent } from './our-app/our-app.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule,
    RouterModule
  ],
  declarations: [
    TopNavigComponent,
    // OurAppComponent
    ],
  exports: [
    TopNavigComponent,
    // OurAppComponent
  ]
})
export class CommonComponentsModule { }
